import type {Variants} from 'motion/react';

export const LayoutTransition: Variants = {
    enter: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1,
            when: 'beforeChildren'
        }
    },
    exit: {
        opacity: 0,
        transition: {
            staggerChildren: 0.1,
            staggerDirection: -1,
            when: 'afterChildren'
        }
    },
    initial: {opacity: 0}
};

export const PagesTransition: Variants = {
    enter: {
        opacity: 1,
        transition: {when: 'beforeChildren'}
    },
    exit: {
        opacity: 0,
        transition: {when: 'afterChildren'}
    },
    initial: {opacity: 0}
};